import { Menu } from '@headlessui/react';
import { UserCircleIcon } from '@heroicons/react/20/solid';
import { useNavigate } from 'react-router-dom';

import { oidcService } from 'src/services/oidcService';

export const UserMenus = () => {
  const navigate = useNavigate();

  return (
    <div className="pt-1">
      <Menu as="div" className="ml-auto relative">
        <Menu.Button className="focus:outline-none">
          <UserCircleIcon className="h-8 w-8 text-primary-700" />
        </Menu.Button>
        <Menu.Items className="absolute z-10 right-0 mt-1 w-44 rounded-md bg-white shadow-lg ring-1 ring-gray-900/5 focus:outline-none py-1">
          <Menu.Item>
            {({ active }) => (
              <button
                onClick={() => navigate('/settings')}
                className={`w-full text-left px-4 py-2 text-sm ${
                  active ? 'bg-gray-50 text-primary-700' : 'text-gray-700'
                }`}
              >
                My Account
              </button>
            )}
          </Menu.Item>
          <Menu.Item>
            {({ active }) => (
              <button
                onClick={() =>
                  navigate('/auth/workspace-select', {
                    state: { userInitiated: true },
                  })
                }
                className={`w-full text-left px-4 py-2 text-sm ${
                  active ? 'bg-gray-50 text-primary-700' : 'text-gray-700'
                }`}
              >
                Select Workspace
              </button>
            )}
          </Menu.Item>
          <div className="border-t border-gray-100 my-1" />
          <Menu.Item>
            {({ active }) => (
              <button
                onClick={() => void oidcService.logout()}
                className={`w-full text-left px-4 py-2 text-sm font-medium ${
                  active ? 'bg-gray-50 text-red-600' : 'text-red-500'
                }`}
              >
                Logout
              </button>
            )}
          </Menu.Item>
        </Menu.Items>
      </Menu>
    </div>
  );
};
